
export const URL_BOOKING = process.env.VUE_APP_BOOKING_URL
export const URL_CASE = process.env.VUE_APP_CASE_URL
export const URL_CLIENT = process.env.VUE_APP_CLIENT_URL
export const URL_CHORES = process.env.VUE_APP_CHORES_URL
export const URL_SETTING = process.env.VUE_APP_SETTING_URL
export const URL_STATISTICS = process.env.VUE_APP_STATISTIC_URL
export const URL_USER = process.env.VUE_APP_USER_URL
export const URL_SPECIALIST = process.env.VUE_APP_SPECIALIST_URL
export const URL_AVAILABILITY = process.env.VUE_APP_AVAILABILITY_URL
